module.exports = __webpack_public_path__ + "static/media/d4kz.78adccca.pdf";